import getTotalEarnings from "../../../utils/getTotalEarnings";

export default function getAverageEarnings(
  earningsData: Partial<RangeEarningsEntry>[],
) {
  const totalEarnings = getTotalEarnings(earningsData);
  if (totalEarnings === 0) {
    return;
  }
  return totalEarnings / earningsData.filter((data) => !!data.earnings).length;
}
